import apiClient from './api';
import type {
  DeviceMetricsResponse,
  DeviceMetricsParams,
  DeviceEventsResponse,
  DeviceEventsParams,
  DeviceCadenceParams,
  HeartbeatCadenceResult,
} from '../types';

export const deviceAnalyticsService = {
  getDeviceMetrics: async (
    deviceId: string,
    params?: DeviceMetricsParams
  ): Promise<DeviceMetricsResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.start) searchParams.set('start', params.start);
    if (params?.end) searchParams.set('end', params.end);
    if (params?.interval) searchParams.set('interval', params.interval);
    if (params?.limit) searchParams.set('limit', String(params.limit));

    const qs = searchParams.toString();
    return apiClient.get<DeviceMetricsResponse>(
      `/devices/${deviceId}/metrics${qs ? `?${qs}` : ''}`
    );
  },

  getDeviceEvents: async (
    deviceId: string,
    params?: DeviceEventsParams
  ): Promise<DeviceEventsResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.start) searchParams.set('start', params.start);
    if (params?.end) searchParams.set('end', params.end);
    if (params?.type) searchParams.set('type', params.type);
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.offset) searchParams.set('offset', String(params.offset));

    const qs = searchParams.toString();
    return apiClient.get<DeviceEventsResponse>(
      `/devices/${deviceId}/events${qs ? `?${qs}` : ''}`
    );
  },

  getDeviceHeartbeatCadence: async (
    deviceId: string,
    params?: DeviceCadenceParams
  ): Promise<HeartbeatCadenceResult> => {
    const searchParams = new URLSearchParams();
    if (params?.start) searchParams.set('start', params.start);
    if (params?.end) searchParams.set('end', params.end);
    if (params?.interval) searchParams.set('interval', params.interval);

    const qs = searchParams.toString();
    return apiClient.get<HeartbeatCadenceResult>(
      `/devices/${deviceId}/heartbeat-cadence${qs ? `?${qs}` : ''}`
    );
  },
};

export default deviceAnalyticsService;
